// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__o61CU","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__2OHy8"};